import { useState } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { scrollToSection } from "../lib/scroll";

const links = [
  { id: "#services", hi: "सेवाएं", en: "SERVICES" },
  { id: "#why-us", hi: "हमें क्यों चुनें", en: "WHY US" },
  { id: "#gallery", hi: "गैलरी", en: "GALLERY" },
  { id: "#process", hi: "प्रक्रिया", en: "PROCESS" },
  { id: "#contact", hi: "संपर्क", en: "CONTACT" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header
      data-testid="main-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0C1B24]/80 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-3 group"
        >
          <span className="w-9 h-9 bg-[#00F0FF] flex items-center justify-center transition-colors group-hover:bg-white">
            <Sparkles className="w-5 h-5 text-[#0C1B24]" />
          </span>
          <span className="font-spacemono font-bold tracking-widest text-sm md:text-base">
            SUPER CLEANER
            <span className="hidden md:inline text-[#00F0FF]"> / SERVICES</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.en.toLowerCase().replace(" ", "-")}`}
              onClick={() => go(l.id)}
              className="font-mukta text-sm text-slate-300 hover:text-[#00F0FF] transition-colors"
            >
              {l.hi}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="header-demo-cta"
            onClick={() => go("#booking")}
            className="hidden md:inline-flex items-center gap-2 bg-[#00F0FF] text-[#0C1B24] font-mukta font-semibold text-sm px-6 py-2.5 hover:bg-white transition-colors shadow-[0_0_24px_rgba(0,240,255,0.3)]"
          >
            Enquiry करें
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-white/10 bg-[#0C1B24]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.en.toLowerCase().replace(" ", "-")}`}
                onClick={() => go(l.id)}
                className="text-left font-khand text-2xl text-white hover:text-[#00F0FF] transition-colors"
              >
                {l.hi}
                <span className="block font-spacemono text-[10px] tracking-[0.3em] text-slate-500">
                  {l.en}
                </span>
              </button>
            ))}
            <button
              data-testid="mobile-demo-cta"
              onClick={() => go("#booking")}
              className="mt-2 bg-[#00F0FF] text-[#0C1B24] font-mukta font-semibold px-6 py-3"
            >
              Enquiry करें
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
